import { render } from "./AlertForm.vue?vue&type=template&id=3adb3c1e"
import script from "./AlertForm.vue?vue&type=script&lang=js"
export * from "./AlertForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__